import { Box, Stack } from '@locus-taxy/encore-mui';
import { ShipmentDetailsContainer } from '../components/EntityDetails/ShipmentDetailsContainer';
import type { FormSchema } from '../components/EntityDetails/types';

interface ShipmentDetailsPageContainerProps {
  clientId?: string;
  entityName?: string;
  entityTitle?: string;
  rootInstanceKey?: string;
  entityData?: Record<string, unknown>;
  detailsForm?: FormSchema;
  showTimeline?: boolean;
  remountKey?: number;
  entitySchemaInfo?: unknown;
}

export const ShipmentDetailsPageContainer = ({
  clientId = '',
  entityName = '',
  entityTitle = '',
  rootInstanceKey,
  entityData = {},
  detailsForm,
  showTimeline = false,
  remountKey = 0,
  entitySchemaInfo,
}: ShipmentDetailsPageContainerProps) => {
  return (
    <Stack sx={{ height: '100%', overflow: 'hidden' }}>
      {/* Content */}
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <ShipmentDetailsContainer
          clientId={clientId}
          entityName={entityName}
          entityTitle={entityTitle}
          rootInstanceKey={rootInstanceKey}
          entityData={entityData}
          detailsForm={detailsForm}
          showTimeline={showTimeline}
          remountKey={remountKey}
          entitySchemaInfo={entitySchemaInfo}
        />
      </Box>
    </Stack>
  );
};
